import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useConfigStore = defineStore(
	'config',
	() => {
		// State
		const theme = ref<'light' | 'dark'>('light')

		// Getters
		const getCurrentTheme = computed(() => theme.value)

		// Actions
		function toggleTheme() {
			theme.value = theme.value === 'light' ? 'dark' : 'light'
		}

		function setTheme(newTheme: 'light' | 'dark') {
			theme.value = newTheme
		}

		return { theme, getCurrentTheme, toggleTheme, setTheme }
	},
	{
		persist: piniaPluginPersistedstate.cookies({
			maxAge: 365 * 24 * 60 * 60
		})
	}
)
// This store manages the theme configuration for the application.
// It uses Pinia for state management and persists the theme setting in cookies.
